import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBookmarkedFalse = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.125 3.5a.6.6 0 0 0-.433.188.7.7 0 0 0-.192.485v15.221l4.21-4.357a.75.75 0 0 1 1.08 0L17 19.394V4.174a.7.7 0 0 0-.192-.486.6.6 0 0 0-.433-.188zm-1.512-.854C7.01 2.236 7.553 2 8.125 2h8.25c.572 0 1.115.235 1.512.646.395.409.613.959.613 1.527V21.25a.75.75 0 0 1-1.29.521l-4.96-5.134-4.96 5.134A.75.75 0 0 1 6 21.25V4.173c0-.568.218-1.118.613-1.527"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBookmarkedFalse;
